const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const uuidRegex = new RegExp(`^${UUID}$`, 'i');
const hasTrim = !!String.prototype.trim;
function onNonNull(value, fn) {
    return value != null ? fn(value) : value;
}
function safeToString(value) {
    return typeof value === 'object' ? JSON.stringify(value) : ('' + value);
}
function nonNull(value) {
    return value != null;
}
function isNonEmpty(value) {
    return nonNull(value) && trim(value).length > 0;
}
function isUUID(value) {
    return !!value && uuidRegex.test(trim(value));
}
function isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
}
function trim(value) {
    return hasTrim ? ('' + value).trim() : ('' + value).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
function isString(str) {
    return typeof str === 'string';
}
function strEqualsIgnoreCase(fistStr, secondStr) {
    return isString(fistStr) && isString(secondStr) && trim(fistStr.toLowerCase()) === trim(secondStr.toLowerCase());
}
function isObject(obj) {
    return !!obj && typeof obj === 'object' && !isArray(obj);
}
function isRecord(obj) {
    return isObject(obj);
}
function isFunction(fun) {
    return !!fun && typeof fun === 'function';
}
function _expiresIn(expires, number) {
    return new Date((new Date().getTime() + (expires * number)));
}
function expiresInDays(expires) {
    return _expiresIn(expires, 864e5);
}
function expiresInHours(expires) {
    return _expiresIn(expires, 36e5);
}
function wrapError(name, e, message) {
    if (isObject(e)) {
        let error;
        if ('message' in e && typeof e.message === 'string') {
            error = new Error(message || e.message);
        }
        else {
            error = new Error(message);
        }
        error.name = name;
        if ('stack' in e && typeof e.stack === 'string') {
            error.stack = e.stack;
        }
        if ('lineNumber' in e && typeof e.lineNumber === 'number') {
            error.lineNumber = e.lineNumber;
        }
        if ('columnNumber' in e && typeof e.columnNumber === 'number') {
            error.columnNumber = e.columnNumber;
        }
        return error;
    }
    else {
        const error = Error(message);
        error.name = name;
        return error;
    }
}

const ERRORS_CHANNEL = 'li_errors';

class ReplayEmitter {
    data;
    constructor(replaySize) {
        const size = parseInt(replaySize.toString()) || 5;
        this.data = {
            h: {},
            q: {},
            size
        };
    }
    on(name, callback, ctx) {
        const handler = {
            callback: callback.bind(ctx),
            unbound: callback
        };
        this.data = { ...this.data, h: { ...this.data.h, [name]: [...(this.data.h[name] || []), handler] } };
        (this.data.q[name] || []).forEach(i => callback.call(ctx, i));
        return this;
    }
    once(name, callback, ctx) {
        const eventQueue = this.data.q[name] || [];
        if (eventQueue.length > 0) {
            callback.call(ctx, eventQueue[0]);
            return this;
        }
        else {
            const listener = (args) => {
                this.off(name, listener);
                callback.call(ctx, args);
            };
            listener._ = callback;
            return this.on(name, listener, ctx);
        }
    }
    emit(name, event) {
        (this.data.h[name] || []).forEach(i => i.callback(event));
        const queue = this.data.q[name] || [];
        this.data = {
            ...this.data,
            q: {
                ...this.data.q,
                [name]: [...(queue.length < this.data.size ? queue : queue.slice(1)), event]
            }
        };
        return this;
    }
    off(name, callback) {
        const handlers = this.data.h[name];
        const liveHandlers = (handlers && callback && handlers.filter(h => h.unbound !== callback)) || [];
        if (liveHandlers.length) {
            this.data = { ...this.data, h: { ...this.data.h, [name]: liveHandlers } };
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [name]: _, ...rest } = this.data.h;
            this.data = { ...this.data, h: rest };
        }
        return this;
    }
    emitErrorWithMessage(name, message, exception) {
        const wrappedError = wrapError(name, exception, message);
        return this.emit(ERRORS_CHANNEL, wrappedError);
    }
    emitError(name, exception) {
        const wrappedError = wrapError(name, exception);
        return this.emit(ERRORS_CHANNEL, wrappedError);
    }
}

export { ERRORS_CHANNEL, ReplayEmitter, UUID, expiresInDays, expiresInHours, isArray, isFunction, isNonEmpty, isObject, isRecord, isString, isUUID, nonNull, onNonNull, safeToString, strEqualsIgnoreCase, trim, wrapError };
